"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const forms_v2_1 = __importStar(require("@kyruus/forms-v2"));
const react_1 = require("@xstate/react");
const prop_types_1 = require("prop-types");
const react_2 = __importStar(require("react"));
const xstate_1 = require("xstate");
const configUtils_1 = require("../../lib/configUtils");
const Actions_1 = require("../../lib/constants/Actions");
const States_1 = require("../../lib/constants/States");
const utils_1 = require("../../lib/utils");
const Tracking_1 = require("../../lib/constants/Tracking");
const Banners_1 = require("../Banners");
const EhrPatientInfo_1 = __importDefault(require("../EhrPatientInfo"));
const Loading_1 = require("../Loading");
const ProxyBookingControls_1 = __importDefault(require("../ProxyBookingControls/ProxyBookingControls"));
const Recaptcha_1 = require("../Recaptcha");
const RegForm_1 = require("../RegForm");
const ApptTypeDisclaimer_1 = __importDefault(require("./ApptTypeDisclaimer"));
const EhrLoginLogout_1 = require("./EhrLoginLogout");
const constants_1 = require("./constants");
const react_3 = require("@emotion/react");
const intl_1 = require("@kyruus/intl");
const ui_theme_1 = require("@kyruus/ui-theme");
const thirdPartyLogin_1 = require("../../lib/constants/thirdPartyLogin");
const thirdPartyLoginUtils_1 = require("../../lib/thirdPartyLoginUtils");
const useWindowWidth_1 = __importDefault(require("../../lib/useWindowWidth"));
const CompactProviderCard_1 = __importDefault(require("../CompactProviderCard/CompactProviderCard"));
const styles_1 = require("./styles");
const RegisterPatientForWaitlist_1 = __importDefault(require("../RegForm/RegisterPatientForWaitlist"));
const propTypes = {
    service: (0, prop_types_1.instanceOf)(xstate_1.Interpreter).isRequired,
    /* eslint-disable react/forbid-prop-types */
    config: prop_types_1.object.isRequired,
    intl: (0, prop_types_1.shape)({
        locale: prop_types_1.string.isRequired,
        formatMessage: prop_types_1.func.isRequired
    }).isRequired,
    thirdPartyLoginProps: (0, prop_types_1.shape)({
        type: (0, prop_types_1.oneOf)(['mychart']).isRequired,
        isLoggedIn: prop_types_1.bool.isRequired,
        login: (0, prop_types_1.shape)({
            url: prop_types_1.string,
            callback: prop_types_1.func.isRequired
        }).isRequired,
        logout: (0, prop_types_1.shape)({
            url: prop_types_1.string,
            callback: prop_types_1.func.isRequired
        }).isRequired,
        errors: (0, prop_types_1.arrayOf)((0, prop_types_1.oneOf)(Object.values(thirdPartyLogin_1.ERROR)))
    }),
    track: prop_types_1.func.isRequired
};
function PatientInfo({ config, service, intl, thirdPartyLoginProps = {}, track }) {
    const [state, send] = (0, react_1.useService)(service);
    const { provider, patientRegForm, insuranceOptions, appointmentQuery, selectedAppointment, updatedFields, csrfToken, ehr, ehrPatientList, selectedPatientIndex, featureFlags, customerCode, productName, apiBaseURL } = state.context;
    const theme = (0, react_3.useTheme)();
    const formRef = (0, react_2.useRef)(null);
    const waitlistRef = (0, react_2.useRef)(null);
    const { aboveMd } = (0, useWindowWidth_1.default)();
    const formBreakpoints = (0, react_2.useMemo)(() => (0, configUtils_1.isDirectBookRenderedInDrawer)(config, featureFlags)
        ? { screen_medium: (0, ui_theme_1.fromTheme)('db_screen_medium')({ theme }) }
        : undefined, [config, theme]);
    (0, react_2.useEffect)(() => {
        const inputId = 'session';
        if (formRef.current &&
            formRef.current.querySelector &&
            !formRef.current.querySelector(`#${inputId}`)) {
            // create new input element
            const hiddenInput = document.createElement('input');
            // set id, hidden, value, data-testid attrs
            hiddenInput.setAttribute('id', inputId);
            hiddenInput.setAttribute('hidden', '');
            hiddenInput.setAttribute('value', csrfToken);
            hiddenInput.setAttribute('data-testid', inputId);
            // append to the form (referenced by formRef)
            formRef.current.appendChild(hiddenInput);
        }
    }, [csrfToken, formRef.current]);
    const loginProps = (0, react_2.useMemo)(() => (0, thirdPartyLoginUtils_1.getLoginPropsWithIntl)({ thirdPartyLoginProps, intl }), [intl, thirdPartyLoginProps]);
    if (state.matches(`${States_1.patientForm}.${States_1.fetchingPatientRegForm}`) ||
        state.matches(`${States_1.patientForm}.${States_1.verifyingPatientRegForm}`)) {
        return react_2.default.createElement(Loading_1.LoadingPatientInfo, null);
    }
    const phone = (0, configUtils_1.shouldHideSchedulingHelpMessages)(config)
        ? ''
        : (0, utils_1.getMainContactNumber)(provider);
    const { fields, fieldSections, disclaimer, addOns, isRequiredMarker, isNotRequiredMarker, apptTypeDisclaimers } = patientRegForm;
    const { editable_demographic_fields: editableDemographicFields = [], editable_demographic_fields_add_ons: editableDemographicFieldsAddOns, ehr_missing_demographics_banner_text: ehrMissingDemographicsBannerText } = config;
    if (state.matches(`${States_1.ehrData}.${States_1.ehrForm}`) ||
        state.matches(`${States_1.ehrData}.${States_1.ehrFormRelatedFailed}`) ||
        state.matches(`${States_1.ehrData}.${States_1.ehrFormNoDropdown}`)) {
        // if we have ehrPatientDemographics then it's the editableDemographicFields we need to update (EHR flow)
        editableDemographicFields.forEach((item) => {
            if (item.path && item.path.includes('plan_name')) {
                item.options = insuranceOptions.map((name) => ({
                    label: name,
                    value: name
                }));
            }
        });
    }
    else if (state.matches(`${States_1.ehrData}.${States_1.ehrSomebodyElseForm}`) ||
        state.matches(`${States_1.ehrData}.${States_1.ehrSomebodyElseFormRelatedFailed}`) ||
        state.matches(`${States_1.ehrData}.${States_1.ehrMainFailed}`) ||
        state.matches(`${States_1.ehrData}.${States_1.ehrSubFailed}`) ||
        state.matches(`${States_1.ehrData}.${States_1.freeform}`)) {
        fields.forEach((item) => {
            if (item.path && item.path.includes('plan_name')) {
                item.options = insuranceOptions.map((name) => ({
                    label: name,
                    value: name
                }));
            }
        });
    }
    const isWaitlistFieldValid = () => {
        if (waitlistRef.current) {
            const waitlistValidation = waitlistRef.current.validateWaitlist();
            if (!waitlistValidation.isValid) {
                waitlistRef.current.scrollToView();
                return false;
            }
        }
        return true;
    };
    const handleSubmit = (payload, done) => {
        /* this fn gets called when there are no validation errors.
         * No harm in calling the done method here
         */
        done(); // Remove any old validation errors from patient info form
        if (!isWaitlistFieldValid()) {
            return;
        }
        send({
            type: Actions_1.BOOK_APPT,
            data: {
                patientRegistration: payload
            }
        });
        track(Tracking_1.userEvents.BOOK_APPT);
    };
    // handle submit for the EHR flow
    const ehrHandleSubmit = (payload, done) => {
        /* this fn gets called when there are no validation errors.
         * No harm in calling the done method here
         */
        done(); // Remove any old validation errors from patient info form
        if (!isWaitlistFieldValid()) {
            return;
        }
        const demographics = ehrPatientList[selectedPatientIndex].demographics;
        send({
            type: Actions_1.BOOK_APPT,
            data: {
                patientRegistration: Object.assign(Object.assign({}, payload), { address: Object.assign(Object.assign({}, demographics.address), payload.address), patient: Object.assign(Object.assign({}, demographics), payload.patient) })
            }
        });
        track(Tracking_1.userEvents.BOOK_APPT);
    };
    // persists user-filled form data
    // (without saving "isRequired" errors, ie. errors with no value)
    const handleChange = ({ updatedFields }) => {
        Object.keys(updatedFields).forEach((field) => {
            if (!updatedFields[field].value) {
                updatedFields[field].errors = [];
            }
        });
        send({ type: Actions_1.FORM_CHANGE, data: { updatedFields } });
    };
    const handleTrack = (eventName, eventData) => {
        const { field_name, field_value } = eventData;
        const updatedEventData = Object.assign({ field_name }, (field_value && constants_1.REG_FORM_VALUE_WHITELIST.includes(field_name)
            ? { field_value }
            : {}));
        track(eventName.replace('user_action.', 'user_action.patient_reg_form.'), updatedEventData);
    };
    const handleCaptchaVerified = (isCaptchaVerified) => {
        send({
            type: Actions_1.CAPTCHA_VERIFIED,
            data: isCaptchaVerified
        });
    };
    const handleCaptchaCancelled = () => {
        send(Actions_1.CAPTCHA_CANCELLED);
    };
    const handleCaptchaError = () => {
        send(Actions_1.CAPTCHA_ERROR);
    };
    const handleCaptchaReset = () => {
        send(Actions_1.CAPTCHA_RESET);
    };
    return (react_2.default.createElement(react_2.default.Fragment, null,
        !aboveMd && (react_2.default.createElement(styles_1.StyledCompactProviderCardContainer, { "data-testid": "compact-provider-card-container" },
            react_2.default.createElement(CompactProviderCard_1.default, { provider: provider, selectedAppointment: selectedAppointment }))),
        state.matches(`${States_1.patientForm}.${States_1.error}`) && aboveMd && (react_2.default.createElement(styles_1.WarningMessageWrapper, { "data-testid": "error-banner-wrapper" },
            react_2.default.createElement(Banners_1.ErrorBookingBanner, { phone: phone }))),
        aboveMd && state.matches(`${States_1.patientForm}.${States_1.apptUnavailable}`) && (react_2.default.createElement(styles_1.WarningMessageWrapper, { "data-testid": "appt-unavailable-banner-wrapper" },
            react_2.default.createElement(Banners_1.AppointmentUnavailableBanner, null))),
        loginProps && (react_2.default.createElement(EhrLoginLogout_1.EhrLoginLogout, { intl: intl, loginProps: loginProps, callbackProps: {
                patientRel: appointmentQuery.patientRel,
                purpose: appointmentQuery.purpose.name,
                selectedAppointment
            }, track: track })),
        ehr && react_2.default.createElement(ProxyBookingControls_1.default, { service: service }),
        (state.matches(`${States_1.ehrData}.${States_1.routing}`) ||
            state.matches(`${States_1.ehrData}.${States_1.pendingEhrPatientDemographics}`)) && (react_2.default.createElement(Loading_1.LoadingPatientInfo, null)),
        (state.matches(`${States_1.ehrData}.${States_1.ehrForm}`) ||
            state.matches(`${States_1.ehrData}.${States_1.ehrFormNoDropdown}`) ||
            state.matches(`${States_1.ehrData}.${States_1.ehrFormRelatedFailed}`)) && (react_2.default.createElement(EhrPatientInfo_1.default, { formBreakpoints: formBreakpoints, ehrPatientDemographics: ehrPatientList[selectedPatientIndex].demographics, bannerText: ehrMissingDemographicsBannerText, handleChange: handleChange, handleTrack: handleTrack, handleSubmit: ehrHandleSubmit, updatedFields: updatedFields, fields: editableDemographicFields, isRequiredMarker: isRequiredMarker, isNotRequiredMarker: isNotRequiredMarker, disclaimer: disclaimer, addOns: editableDemographicFieldsAddOns, service: service, config: config, provider: provider, formRef: formRef, waitlistRef: waitlistRef })),
        [
            `${States_1.ehrData}.${States_1.freeform}`,
            `${States_1.ehrData}.${States_1.ehrMainFailed}`,
            `${States_1.ehrData}.${States_1.ehrSubFailed}`,
            `${States_1.ehrData}.${States_1.ehrSomebodyElseForm}`,
            `${States_1.ehrData}.${States_1.ehrSomebodyElseFormRelatedFailed}`
        ].some(state.matches) && (
        /* we need to set a negative margin-top to offset the margin-top of the labels in the form's first row
        there is a ticket (https://kyruus.jira.com/browse/KENG-11185) to make a fix in forms-v2
        so that this negative margin-top won't be necessary */
        react_2.default.createElement(styles_1.NegativeMarginTopSpacingMediumWrapper, null,
            react_2.default.createElement("div", { "data-testid": "PatientInfo" },
                react_2.default.createElement(ApptTypeDisclaimer_1.default, { provider: provider, apptTypeDisclaimers: apptTypeDisclaimers }),
                react_2.default.createElement(forms_v2_1.default, { breakpoints: formBreakpoints, onChange: handleChange, onTrack: handleTrack, onSubmit: handleSubmit, updatedFields: updatedFields, fields: fields, fieldSections: fieldSections, isRequiredMarker: isRequiredMarker, isNotRequiredMarker: isNotRequiredMarker, hideDefaultSubmit: true, formRef: formRef },
                    (0, forms_v2_1.getAddOns)(addOns, handleTrack),
                    react_2.default.createElement(forms_v2_1.Footer, null, ({ handleSubmit, handleTrack }) => {
                        return (react_2.default.createElement(react_2.default.Fragment, null,
                            react_2.default.createElement(RegisterPatientForWaitlist_1.default, { service: service, ref: waitlistRef }),
                            react_2.default.createElement(RegForm_1.RegFormFooterContent, { disclaimer: disclaimer, handleTrack: handleTrack, handleSubmit: handleSubmit, service: service, provider: provider, config: config })));
                    }))))),
        state.matches(`${States_1.patientForm}.${States_1.verifyingCaptcha}`) && (react_2.default.createElement(Recaptcha_1.RecaptchaModal, { onCancel: handleCaptchaCancelled, onVerified: handleCaptchaVerified, onError: handleCaptchaError, siteKey: config.recaptchaSiteKey, customerCode: customerCode, productName: productName, apiBaseURL: apiBaseURL })),
        state.matches(`${States_1.patientForm}.${States_1.verifyingCaptchaError}`) && (react_2.default.createElement(Recaptcha_1.RecaptchaErrorModal, { onClose: handleCaptchaCancelled, onReset: handleCaptchaReset }))));
}
PatientInfo.propTypes = propTypes;
exports.default = (0, intl_1.injectIntl)(PatientInfo);
//# sourceMappingURL=PatientInfo.js.map